<template>
  <div class="footer">
    <div class="left">
      <Icon name="checked" />
      Выбрано:
      <b>{{ isSelectAll ? 'всё' : getCounter }}</b>
    </div>

    <div class="actions">
      <a
        v-if="!['analytics_calls', 'analytics_incoming'].includes(page)"
        @click="confirmDelete"
        class="button delete"
      >
        Удалить выбранные
      </a>
      <a
        v-if="['analytics_calls', 'analytics_incoming'].includes(page)"
        @click="exportSelectedAnalyticsCalls"
        class="button export"
        >Экспортировать выбранные</a
      >
      <a
        v-if="page === 'carousels'"
        @click="exportSelectedCarousels"
        class="button export"
      >
        Экспортировать выбранные
      </a>

      <a
        v-if="page === 'calls'"
        @click="exportUncalledSelected"
        class="button export"
      >
        Экспорт непрозвоненных
      </a>

      <a
        v-if="page === 'base_main'"
        @click="exportSelected"
        class="button export"
      >
        Экспорт
      </a>

      <a
        v-if="page === 'base_main'"
        @click="showDeleteContactsConfirm = true"
        class="button delete"
      >
        Удалить контакты
      </a>

      <a v-if="page === 'calls'" @click="resume" class="button resume">
        Возобновить выбранные
      </a>

      <a v-if="page === 'calls'" @click="stop" class="button stop">
        Остановить выбранные
      </a>
      <a
        v-if="page === 'calls' && getCounter > 0"
        @click="openBulkEdit"
        class="button"
      >
        Редактировать выбранные
      </a>
      <a
        v-if="page === 'scripts'"
        @click="exportSelectedScripts"
        class="button export"
      >
        Экспортировать выбранные
      </a>
    </div>

    <v-dialog v-model="showDeleteContactsConfirm" max-width="460" persistent>
      <v-card class="delete-contacts-modal">
        <button
          class="delete-contacts-modal__close"
          @click="showDeleteContactsConfirm = false"
        >
          <v-icon>mdi-close</v-icon>
        </button>

        <div class="delete-contacts-modal__icon">
          <v-icon>mdi-alert-outline</v-icon>
        </div>

        <div class="delete-contacts-modal__title">Удалить контакты?</div>

        <div class="delete-contacts-modal__text">
          Точно удалить выбранные записи?
        </div>

        <div class="delete-contacts-modal__warning">
          Контакты будут удалены без возможности восстановления. Сами базы и их
          чёрные списки останутся без изменений.
        </div>

        <div class="delete-contacts-modal__actions">
          <button
            class="delete-contacts-modal__button delete-contacts-modal__button--cancel"
            @click="showDeleteContactsConfirm = false"
          >
            Отмена
          </button>

          <button
            class="delete-contacts-modal__button delete-contacts-modal__button--delete"
            @click="confirmDeleteContacts"
          >
            Удалить контакты
          </button>
        </div>
      </v-card>
    </v-dialog>

    <Error
      :callback_refresh="clearRefreshFooter"
      :show_dialog="show_dialog_error"
      :title="show_dialog_error_message"
      :btn="{ text: show_dialog_error_btn }"
    />
    <ExportBase :show.sync="showExport" :guid="multiGuid" />
    <BulkEditCalls
      :show_dialog="showBulkEdit"
      :selected_calls="
        $store.getters['notification/getFooterState']?.data || []
      "
      @close="showBulkEdit = false"
    />
  </div>
</template>

<script>
import Error from '../components/Modal/ErrorModal.vue';
import BulkEditCalls from '@/components/Modal/Calls/BulkEditCalls.vue';
import Icon from './SetIcon.vue';

export default {
  components: {
    Icon,
    Error,
    BulkEditCalls,
    ExportBase: () => import('@/components/Modal/Bases/ExportBase.vue'),
  },

  data() {
    return {
      showExport: false,
      showBulkEdit: false,
      page: 'none',
      show_dialog_error: false,
      show_dialog_error_message: '',
      show_dialog_error_btn: '',
      multiGuid: [],
      showDeleteContactsConfirm: false,
    };
  },

  mounted() {
    const st = this.$store.getters['notification/getFooterState'];
    this.page = st && st.page_type ? st.page_type : 'none';
  },

  computed: {
    getCounter() {
      const st = this.$store.getters['notification/getFooterState'];
      return st && st.data ? st.data.length : 0;
    },
    isSelectAll() {
      const st = this.$store.getters['notification/getFooterState'];
      return !!(st && st.selectAllVirtual);
    },
  },

  methods: {
    exportSelectedScripts() {
      const state = this.$store.getters['notification/getFooterState'] || {};

      const selected = Array.isArray(state.data) ? state.data : [];

      // console.log('Скрипты из нижней панели:', selected);

      if (!selected.length) return;
      if (typeof state.cb_export !== 'function') return;

      state.cb_export(selected);
    },
    exportSelectedAnalyticsCalls() {
      const state = this.$store.getters['notification/getFooterState'];

      const selected = state?.data || [];

      if (!selected.length || !state.cb_export) return;

      state.cb_export(selected);
    },
    openBulkEdit() {
      if (!this.getCounter) return;
      this.showBulkEdit = true;
    },
    async exportUncalledSelected() {
      const st = this.$store.getters['notification/getFooterState'];
      const selected = (st && st.data) || [];
      if (!selected.length) return;

      const selection = selected.map((item) => ({
        id: item.guid,
        base: item.select_base,
      }));

      alert('Отчёт начал формироваться');

      try {
        await this.$http.download('/call/exportUnCalled', {
          params: JSON.stringify({ selection }),
        });
        alert('Файл загружен');
      } catch (err) {
        console.error('Ошибка экспорта:', err);
        if (this.$notify) {
          this.$notify({
            type: 'error',
            text: 'Не удалось выгрузить файл',
          });
        } else {
          alert('Не удалось выгрузить файл');
        }
      }
    },

    confirmDelete() {
      if (!this.getCounter) return;
      if (confirm('Точно удалить выбранные записи?')) {
        this.deleteTable();
      }
    },

    confirmDeleteContacts() {
      this.showDeleteContactsConfirm = false;
      const st = this.$store.getters['notification/getFooterState'];
      const selectedBases = st?.data || [];

      if (!selectedBases.length) return;

      let completed = 0;

      selectedBases.forEach((base) => {
        this.$http.post(
          '/base/leads',
          {
            id: base.guid,
            filters: {
              selectAll: true,
              blacklist: 0,
            },
          },
          () => {
            completed++;

            if (completed === selectedBases.length) {
              this.clearRefreshFooter();
            }
          },
        );
      });
    },

    exportSelected() {
      const st = this.$store.getters['notification/getFooterState'];
      const data = (st && st.data) || [];
      const ids = data.map((el) => el && el.guid).filter(Boolean);

      if (!ids.length) return;

      this.multiGuid = ids;
      this.showExport = true;
    },

    async clearRefreshFooter() {
      const st = this.$store.getters['notification/getFooterState'];

      if (st && typeof st.cb_refresh === 'function') st.cb_refresh();
      if (st && typeof st.cb_clear === 'function') st.cb_clear();

      const data = {
        hide: true,
        data: [],
        page_type: 'none',
        cb_refresh: false,
        cb_clear: false,
      };

      this.$store.commit('notification/setFooterState', data);

      setTimeout(() => {
        window.location.reload();
      }, 300);
    },

    deleteTable() {
      const st = this.$store.getters['notification/getFooterState'];

      if (st && st.selectAllVirtual && typeof st.cb_delete === 'function') {
        st.cb_delete();
        return;
      }

      const arr = (st && st.data) || [];
      const list_guid = arr
        .map((el) => (el && el.guid ? el.guid : el))
        .filter(Boolean);

      const sel = (st && st.data) || [];
      const footerPage = st && st.page_type;

      switch (footerPage) {
        case 'carousels': {
          const ids = sel
            .filter((el) => el.rowType !== 'segment')
            .map((el) => el.guid)
            .filter(Boolean);

          const delOne = (id) =>
            new Promise((resolve) => {
              this.$http.post('/numbers/carousel_delete', { id }, (res) =>
                resolve(res),
              );
            });

          (async () => {
            let fail = 0;
            for (const id of ids) {
              const res = await delOne(id);
              if (res === 'error' || !res?.ok) fail++;
            }
            if (fail) {
              alert(`Не удалось удалить: ${fail} из ${ids.length}`);
            }
            this.clearRefreshFooter();
          })();
          break;
        }
        case 'base_main':
          this.$http.post('/base/batchdelete', { data: list_guid }, () =>
            this.clearRefreshFooter(),
          );
          break;

        case 'base_phones':
        case 'base_black':
          this.$http.post('/base/batchdeletelead', { data: list_guid }, () =>
            this.clearRefreshFooter(),
          );
          break;

        case 'scripts':
          this.$http.post('/script/batchdelete', { data: list_guid }, () =>
            this.clearRefreshFooter(),
          );
          break;

        case 'calls':
          this.$http.post('/call/batchdelete', { data: list_guid }, () =>
            this.clearRefreshFooter(),
          );
          break;
        case 'integration': {
          const ids = sel.map((el) => el.id || el.guid).filter(Boolean);

          let done = 0;

          ids.forEach((id) => {
            this.$http.post(
              '/integrations/delete',
              {
                type: 'AmoCRM',
                id,
              },
              () => {
                done++;

                if (done === ids.length) {
                  this.clearRefreshFooter();
                }
              },
            );
          });

          break;
        }
        default:
          break;
      }
    },

    resume() {
      const st = this.$store.getters['notification/getFooterState'];
      const arr = (st && st.data) || [];
      const footerPage = st && st.page_type;

      const filteredListGuid = arr
        .filter((element) => element.status !== 'success')
        .map((element) => element.guid);

      if (filteredListGuid.length > 50) {
        const msg = `Нельзя запускать более 50 обзвонов за раз`;
        if (this.$notify) {
          this.$notify({ type: 'error', text: msg });
        } else {
          alert(msg);
        }
        return;
      }

      switch (footerPage) {
        case 'calls':
          this.$http.post(
            '/call/resume',
            { data: filteredListGuid },
            (data) => {
              if (data.errored) {
                this.show_dialog_error = true;
                this.show_dialog_error_message = data.error_message;
                this.show_dialog_error_btn = 'Понятно';

                if (
                  data.error_message === 'Вам необходимо активировать аккаунт'
                ) {
                  this.show_dialog_error_btn = 'Активировать';
                }
              } else {
                this.clearRefreshFooter();
              }
            },
          );
          break;

        default:
          break;
      }
    },

    stop() {
      const st = this.$store.getters['notification/getFooterState'];
      const arr = (st && st.data) || [];
      const footerPage = st && st.page_type;

      const filteredListGuid = arr
        .filter((element) => element.status !== 'success')
        .map((element) => element.guid);

      switch (footerPage) {
        case 'calls':
          this.$http.post('/call/stopChosen', { data: filteredListGuid }, () =>
            this.clearRefreshFooter(),
          );
          break;

        default:
          break;
      }
    },
    async exportSelectedCarousels() {
      const st = this.$store.getters['notification/getFooterState'];
      const selected = (st && st.data) || [];
      const ids = selected
        .map((item) => item?.id || item?.guid)
        .filter(Boolean);

      if (!ids.length) return;

      this.$root.$emit('carousel-export-start');

      try {
        const responses = await Promise.all(
          ids.map(
            (id) =>
              new Promise((resolve) =>
                this.$http.post(
                  '/numbers/all',
                  {
                    carousel: id,
                    active_only: true,
                  },
                  (r) => resolve(r),
                ),
              ),
          ),
        );

        const resp = responses
          .filter((r) => r !== 'error' && Array.isArray(r))
          .flat();

        if (resp === 'error' || !Array.isArray(resp) || !resp.length) {
          alert('Нет номеров для экспорта');
          return;
        }

        const rows = resp.map((r) => ({
          Номер: r.phoneNumber
            ? `+7 (${String(r.phoneNumber)
                .replace(/\D/g, '')
                .slice(-10, -7)}) ${String(r.phoneNumber)
                .replace(/\D/g, '')
                .slice(-7, -4)}-${String(r.phoneNumber)
                .replace(/\D/g, '')
                .slice(-4, -2)}-${String(r.phoneNumber)
                .replace(/\D/g, '')
                .slice(-2)}`
            : '—',
          'Исходящих звонков совершено': r.outboundCalls ?? '—',
          Карусель: r.carousel ?? '—',
          'Статус карусели': r.carouselStatus ?? '—',
          'Начало аренды': r.rentStart ?? '—',
          'Окончание аренды': r.rentEnd ?? '—',
          'Стоимость аренды': r.rentCost ?? '—',
          Автопродление: r.autoRenew ?? '—',
          'Последний исходящий вызов': r.lastOutboundCall ?? '—',
        }));

        const { default: ExcelJS } = await import('exceljs');
        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet('Numbers');

        const headers = Object.keys(rows[0]);
        ws.addRow(headers);
        rows.forEach((row) => ws.addRow(headers.map((key) => row[key])));

        ws.getRow(1).font = { bold: true };

        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'selected_carousels_numbers.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error(e);
        alert('Экспорт не удался');
      } finally {
        this.$root.$emit('carousel-export-end');
      }
    },
  },
};
</script>

<style scoped>
.footer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.left {
  display: flex;
  align-items: center;
}

.left .icon {
  margin-right: 10px;
  margin-left: 16px;
}

.actions {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 32px;
  white-space: nowrap;
}

.button {
  background: none;
  border: none;
  margin: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 120%;
  cursor: pointer;
}

.button:hover {
  text-decoration: underline;
}

.delete {
  color: #ee505a;
}

.double {
  color: #55575c;
}

.delete-contacts-modal {
  position: relative;
  padding: 32px;
  border-radius: 16px !important;
  text-align: center;
}

.delete-contacts-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.delete-contacts-modal__close .v-icon {
  color: #808185;
  font-size: 22px;
}

.delete-contacts-modal__close:hover .v-icon {
  color: #2b2d33;
}

.delete-contacts-modal__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: #fff0f1;
}

.delete-contacts-modal__icon .v-icon {
  color: #ee505a;
  font-size: 30px;
}

.delete-contacts-modal__title {
  margin-bottom: 12px;
  color: #2b2d33;
  font-size: 24px;
  font-weight: 800;
  line-height: 130%;
}

.delete-contacts-modal__text {
  margin-bottom: 12px;
  color: #2b2d33;
  font-size: 17px;
  font-weight: 500;
  line-height: 140%;
}

.delete-contacts-modal__warning {
  margin-bottom: 28px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f7f7f8;
  color: #808185;
  font-size: 14px;
  line-height: 145%;
}

.delete-contacts-modal__actions {
  display: flex;
  gap: 12px;
}

.delete-contacts-modal__button {
  flex: 1;
  min-height: 44px;
  padding: 12px 18px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 120%;
  cursor: pointer;
}

.delete-contacts-modal__button--cancel {
  border: 1px solid #d9dadd;
  background: #ffffff;
  color: #55575c;
}

.delete-contacts-modal__button--cancel:hover {
  background: #f7f7f8;
}

.delete-contacts-modal__button--delete {
  border: 1px solid #ee505a;
  background: #ee505a;
  color: #ffffff;
}

.delete-contacts-modal__button--delete:hover {
  border-color: #dc414b;
  background: #dc414b;
}

@media (max-width: 500px) {
  .delete-contacts-modal {
    padding: 28px 20px 20px;
  }

  .delete-contacts-modal__actions {
    flex-direction: column-reverse;
  }
}
</style>
